import { EventFormState } from '../../types/events';
import { ExpenseReportFormState } from '../../types/expense-reports';
import { Form, UploadedFileMetadata } from '../../types/forms';
import { NoticeFormState } from '../../types/notices';

export const isWaitingForApproval = (form: Form) => {
  return (
    form.formState === NoticeFormState.AwaitingApproval ||
    form.formState === EventFormState.AwaitingApproval ||
    form.formState === ExpenseReportFormState.AwaitingApproval
  );
};

export const isApproved = (form: Form) => {
  return (
    form.formState === NoticeFormState.Published ||
    form.formState === EventFormState.Published ||
    form.formState === ExpenseReportFormState.Approved
  );
};

export const isRejected = (form: Form) => {
  return (
    form.formState === NoticeFormState.Rejected ||
    form.formState === EventFormState.Rejected ||
    form.formState === ExpenseReportFormState.Rejected
  );
};

export function objectToFormData(obj: any, formData: FormData = new FormData(), parentKey: string = ''): FormData {
  if (obj instanceof File || obj instanceof Blob) {
    formData.append(parentKey, obj);
  } else if (obj instanceof FileList) {
    Array.from(obj).forEach((file, index) => {
      const key = `${parentKey}[${index}]`;
      formData.append(key, file);
    });
  } else if (Array.isArray(obj)) {
    obj.forEach((value, index) => {
      const key = parentKey ? `${parentKey}[${index}]` : String(index);
      objectToFormData(value, formData, key);
    });
  } else if (obj !== null && typeof obj === 'object') {
    Object.entries(obj).forEach(([key, value]) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      objectToFormData(value, formData, fullKey);
    });
  } else if (obj !== undefined && obj !== null) {
    formData.append(parentKey, String(obj));
  } else if (obj !== undefined && obj === null) {
    formData.append(parentKey, '');
  }
  return formData;
}

/**
 * Helper function which can display either the name of a file blob or the name from an already uploaded file's metadata
 */
export function getFileDisplayName(file: File | UploadedFileMetadata | undefined): string {
  if (!file) {
    return '';
  }
  if (file instanceof File) {
    return file.name;
  }
  return file.originalName;
}
